var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.entry)?_c('div',[_c('div',{staticClass:"readonly-wrapper"},[_c('div',{staticClass:"readonly-wrapper__label"},[_vm._v(_vm._s(_vm.$t(_vm.entry.name)))]),_c('div',{staticClass:"readonly-wrapper__value"},[_vm._v(_vm._s(_vm.value || "-"))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }